export class VisitorTypeDto {
    id: string = '';
    code: string = '';
    name: string = '';
    value: string = '';
    sequence: number = 0;
    workflowFormId: string = '';
    remarks: string = '';
}
